import { createElement } from 'react';
import { ItemTypes } from '../Constants';
import { DragSource, DragSourceConnector, DragSourceMonitor } from 'react-dnd';
import { store, ScreenComponentProps, ShelfComponentProps, ComponentDesc, buttonDefaultSettings } from '../store';
import { observer } from 'mobx-react';
import withStyles from 'react-jss';
import HeightWidthEditor from './common/HeightWidthEditor';
import MarginEditor from './common/MarginEditor';
import PaddingEditor from './common/PaddingEditor';
import BorderEdit from './common/BorderEdit';
import BorderRadius from './common/BorderRadius';
import ColorPicker from './common/ColorPicker';
import BackgroundColorPicker from './common/BackgroundColorPicker';
import Typograph from './common/Typograph';
import { settingsComponentStyles } from './common/styles';
import { shelfComponentStyles } from './common/styles';
import { flowRight } from 'lodash';

const svg = require('./icons/button.svg');
//const menu_button = require('./icons/menu_button.svg');

interface ButtonSettings {
    text: string;
    href: string;
}

let defaultTemplate = {
    type: 'BUTTON',
    style: {
        ...buttonDefaultSettings(),
    },
    settings: {
        href: '',
        text: 'Click Here',
    },
    name: 'Button',
};

let shelfComponent = flowRight([
    withStyles(shelfComponentStyles),
    DragSource(
        ItemTypes.COMPONENT,
        {
            beginDrag(props, monitor, component): ComponentDesc<ButtonSettings> {
                let t = JSON.parse(JSON.stringify(defaultTemplate));
                t.id = +new Date();
                return t;
            },
        },
        (connect: DragSourceConnector, monitor: DragSourceMonitor) => {
            return {
                connectDragSource: connect.dragSource(),
                isDragging: monitor.isDragging(),
            };
        }
    ),
])((props: ShelfComponentProps<typeof shelfComponentStyles>) => {
    let { connectDragSource, isDragging, classes } = props;
    return connectDragSource(
        <div className={classes.outer}>
            <div className={classes.section}>
                <img src={svg} className={classes.icon} />
                <span className={classes.label}>Button</span>
            </div>
        </div>
    );
});

function ScreenComponent({ connectDragSource, isDragging, descriptor }: ScreenComponentProps<ButtonSettings>) {
    return (
        <div
            style={{
                opacity: isDragging ? 0.5 : 1,
                cursor: 'move',
                minHeight: '10px',
            }}
            onClick={(e) => store.selectComponent(descriptor)}>
            {descriptor.isStatic ? (
                <a href={descriptor.settings.href ? descriptor.settings.href : ''}>
                    <button
                        style={{
                            ...descriptor.style,
                        }}>
                        {descriptor.settings.text}
                    </button>
                </a>
            ) : (
                <button style={{ ...descriptor.style }}>{descriptor.settings.text}</button>
            )}
        </div>
    );
}

/**
 * Define the settings panel for this component
 * @type {({ descriptor }: any) => any}
 */

const SettingsComponent = flowRight([withStyles(settingsComponentStyles), observer])(({ descriptor, classes }: any) => {
    return (
        <div>
            <div className={classes.root}>
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        height: 75,
                        marginTop: 10,
                    }}>
                    <div
                        style={{
                            display: 'flex',
                            paddingBottom: 5,
                        }}>
                        <span className={classes.header} style={{ width: 81 }}>
                            {' '}
                            Name{' '}
                        </span>
                        <input style={{ textAlign: 'left', paddingLeft: 5 }} type="text" value={descriptor.settings.text} onChange={(e) => (descriptor.settings.text = e.target.value)} className={classes.src + ' btnSettingsText'} />
                    </div>
                    <div
                        style={{
                            display: 'flex',
                        }}>
                        <span className={classes.header} style={{ width: 81 }}>
                            URL
                        </span>
                        <input style={{ textAlign: 'left', paddingLeft: 5 }} type="text" value={descriptor.settings.href} onChange={(e) => (descriptor.settings.href = e.target.value)} className={classes.src} />
                    </div>
                </div>
            </div>
            <div>
                <Typograph descriptor={descriptor} />
                <HeightWidthEditor descriptor={descriptor} /> <MarginEditor descriptor={descriptor} />
                <PaddingEditor descriptor={descriptor} />
                <BorderEdit descriptor={descriptor} />
                <BorderRadius descriptor={descriptor} />
                <BackgroundColorPicker descriptor={descriptor} />
                <ColorPicker descriptor={descriptor} />
            </div>
        </div>
    );
});

store.registerComponent({
    name: 'BUTTON',
    type: 'component',
    shelfComponent: shelfComponent,
    screenComponent: observer(ScreenComponent),
    settingsComponent: SettingsComponent,
    defaultTemplate,
    svg,
});

//export default component;
